<template>
    <div>
        <b-form-group>
            <label class="mr-2">{{ label }}</label
            ><i v-b-tooltip.hover class="far fa-question-circle text-muted" :title="$t('tooltip')" />
            <multiselect
                id="parent-objective"
                :state="state"
                :selected="value"
                trackBy="id"
                :options="options"
                :disabled="disabled"
                :placeholder="$t('insights.selectObjectiveParent')"
                :multiple="false"
                @changeValue="$emit('update:value', $event)"
                :hideSelectedOptions="false"
            >
                <template slot="c-option" slot-scope="{ options: { option } }">
                    <span>{{ option.label }}</span>
                </template>
            </multiselect>
        </b-form-group>
    </div>
</template>

<script>
import { Multiselect } from '@/views/components/selects'
import api from '@/services/api'

export default {
    name: 'ParentSelect',
    components: {
        Multiselect,
    },
    props: ['objectiveId', 'size', 'label', 'value', 'state', 'disabled'],
    data() {
        return {
            options: [],
            parent_id: null,
        }
    },
    watch: {
        objectiveId(val) {
            if (val) {
                this.getPossibleObjectiveParents(val)
            }
        },
    },
    methods: {
        getPossibleObjectiveParents(objectiveId) {
            api.get(`/objectives/${objectiveId}/possible-objective-parents`).then((resp) => {
                this.options = resp.data.map((parent) => {
                    const { id, title } = parent
                    return { id, label: title }
                })
            })
        },
    },
    i18n: {
        messages: {
            'en-US': {
                tooltip:
                    'By linking this objective to a parent, it will appear below the parent in the OKRs organogram chart, and will be used in calculating its performance.',
            },
            'es-ES': {
                tooltip:
                    'Al vincular este objetivo a un principal, aparecerá debajo del principal en el organigrama de OKR y se utilizará para calcular su rendimiento.',
            },
            'pt-BR': {
                tooltip:
                    'Ao vincular este objetivo a um pai, ele aparecerá abaixo do pai no organograma de OKRs, e será utilizado no cálculo de sua performance',
            },
        },
    },
}
</script>
